const themeConfig = {
    version: "1.0",
    theme: "light", // light - dark
    contentWidth: "full", // full - boxed
    sidebarCollapsed: false,
    sidebarCollapseButton: true,
    layout: "HorizontalLayout", // VerticalLayout - HorizontalLayout
    navigationFull: false,
    navigationBg: false,
    direction: "ltr", // ltr - rtl
    language: "en", // tr - en - es - fr
}

export default themeConfig